import React, { useCallback, useState, useEffect } from "react";
import { Button, IconButton } from "@mui/material";
import { IoIosCloseCircleOutline } from "react-icons/io";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import config from "../../api/config";
import { useDispatch } from "react-redux";
import { setToast } from "../../redux/actions/ToastAction";
import CategoryController from "../SelectCat";
import InputForPrice from "../PriceInput";

const EditingCat = ({ cat, _callback, modal, setModal }) => {
  const [cats, setCats] = useState([]);
  const [catId, setCat] = useState(null);
  const [parentCat, setParentCat] = useState(null);
  // texts
  const [textRu, setTextRu] = useState("");
  const [textEn, setTextEn] = useState("");
  const [textUz, setTextUz] = useState("");
  const [price, setPrice] = useState(0);
  const dispatch = useDispatch();
  // all cats
  const getAllCats = useCallback(async () => {
    try {
      const res = await config.get(`/api/category/v1`);
      setCats(res.data.objectKoinot);
    } catch (e) {
      dispatch(setToast(true, "error", e.message));
    }
  }, [dispatch]);
  // get data
  useEffect(() => {
    if (cat) {
      setCat(cat);
      setTextEn(cat.nameEn);
      setTextRu(cat.nameRu);
      setTextUz(cat.nameUz);
      if (cat.parentCategory) setParentCat(cat.parentCategory);
      setPrice(cat.price);
    }
  }, [cat]);

  useEffect(() => { getAllCats(); }, [getAllCats]);

  // change parent
  const changeParentCat = (id) => {
    setParentCat(id);
  };
  const changePrice = (e) => {
    setPrice(e);
  };

  // add parent
  const addParentCat = () => {
    setParentCat(cats[0]);
  };
  const submitHandler = () => {
    let catCopy = structuredClone(catId);
    if (parentCat && parentCat.id > 0) catCopy.parentCategory = parentCat.id;
    catCopy.price = price;
    catCopy.nameEn = textEn;
    catCopy.nameRu = textRu;
    catCopy.nameUz = textUz;
    _callback(true, catCopy);
  };
  return (
    <div className="control-cat">
      {cat ? (
        <Dialog
          open={modal}
          fullWidth
          maxWidth="md"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            className="d-flex justify-content-between align-items-center px-5 pt-5"
          >
            <h2>{cat.nameRu ? cat.nameRu : "Новая категория"}</h2>
            <IconButton onClick={() => setModal(false)}>
              <IoIosCloseCircleOutline />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <div className="w-100 p-3">
              {parentCat ? (
                <>
                  <p className="mb-0 ms-2 fw-bold">
                    Oтносится к этой категории
                  </p>
                  <CategoryController
                    allCats={cats}
                    className={"my-4"}
                    selectedCat={parentCat}
                    _callback={changeParentCat}
                  />
                </>
              ) : (
                <Button variant="contained" className="mb-4" onClick={() => addParentCat()}>
                  Добавить в другую категорию
                </Button>
              )}
              <small className="text-muted mb-4"></small>
              <p className="mb-0 ms-2 fw-bold">Русский</p>
              <input
                type="text"
                className="mb-4"
                value={textRu}
                onChange={(e) => setTextRu(e.target.value)}
              />{" "}
              <p className="mb-0 ms-2 fw-bold">Английский</p>
              <input
                type="text"
                className="mb-4"
                value={textEn}
                onChange={(e) => setTextEn(e.target.value)}
              />{" "}
              <p className="mb-0 ms-2 fw-bold">Узбекский</p>
              <input
                type="text"
                className="mb-4"
                value={textUz}
                onChange={(e) => setTextUz(e.target.value)}
              />
              <p className=" ms-2 fw-bold">Цена</p>
              <InputForPrice value={price} onChange={changePrice} />
            </div>
          </DialogContent>
          <DialogActions className="px-5 pb-3">
            <Button onClick={submitHandler} variant="contained" color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
    </div>
  );
};

export default EditingCat;
